module.exports = __webpack_public_path__ + "static/media/feb 2021.2f2bb678.svg";